import React, { useState } from 'react';
import { ArrowLeft, Eye, EyeSlash } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminChangeMobile = ({ onBack }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const goBack = onBack || (() => navigate(-1));
  const [password, setPassword] = useState('');
  const [newMobile, setNewMobile] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!password) {
      toast.error('Enter your admin password');
      return;
    }
    if (!newMobile || newMobile.length < 5) {
      toast.error('Enter valid mobile number');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/admin/update-mobile`, {
        admin_id: user.id,
        password: password,
        new_mobile: newMobile
      });
      toast.success('Mobile number updated! Please login again.');
      setTimeout(() => window.location.href = '/admin-login', 1500);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update mobile');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-[#075E54] text-white px-4 py-3 flex items-center gap-3">
        <button onClick={goBack} className="p-1" data-testid="admin-change-mobile-back"><ArrowLeft size={24} /></button>
        <h1 className="text-lg font-semibold">Change Mobile Number</h1>
      </div>

      <div className="p-4 space-y-4">
        <div className="bg-white rounded-xl p-4 shadow-sm space-y-4">
          <p className="text-sm text-gray-600">Current: <strong>{user?.phone}</strong></p>

          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">Admin Password</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="w-full px-3 py-2 border rounded-lg pr-10 outline-none focus:border-[#075E54]"
                data-testid="admin-password-input"
              />
              <button onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-2.5 text-gray-500">
                {showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">New Mobile Number</label>
            <input
              type="text"
              value={newMobile}
              onChange={(e) => setNewMobile(e.target.value)}
              placeholder="Enter new mobile number"
              className="w-full px-3 py-2 border rounded-lg outline-none focus:border-[#075E54]"
              data-testid="new-mobile-input"
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading || !password || !newMobile}
            className="w-full py-3 bg-[#075E54] text-white rounded-lg font-semibold hover:bg-[#064E46] disabled:opacity-50"
            data-testid="change-mobile-btn"
          >
            {loading ? 'Updating...' : 'Change Mobile Number'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminChangeMobile;
